<div style="display: contents">
  <div class="text-container">
    <ng-content></ng-content>
  </div>
  @if (mode=='gradient') {
  <div class="masthead-gradient-background"></div>
  }
</div>
